import React from "react";
import AboutSection from "@/components/sections/AboutSection";
import ProcessSection from "@/components/sections/ProcessSection";
import ContactForm from "@/components/sections/ContactForm";
import { useLang } from "@/contexts/LanguageContext";

const About = () => {
  const { t } = useLang();
  return (
    <div data-testid="about-page">
      <section className="bg-white border-b border-brand-border">
        <div className="container-x pt-24 pb-16 sm:pt-32 sm:pb-20">
          <p className="overline">{t.about.eyebrow}</p>
          <h1 className="mt-5 font-heading font-bold text-brand-ink text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] max-w-4xl">
            {t.about.title}
          </h1>
        </div>
      </section>
      <AboutSection />
      <ProcessSection />
      <ContactForm />
    </div>
  );
};

export default About;
